import React from "react";

import {
  DashboardHeader,
  DashboardSideBar,
} from "../../components/dashboard/layout";

import {
  DashboardHero,
} from "../../components/dashboard";

import {
  useStateContext,
} from "../../context/ContextProvider";


function AdminDashboardPage() {
  const {
    activeMenu,
    setActiveMenu,
    currentDir,
    screenSize,
  } = useStateContext();


  const isRTL =
    currentDir === "rtl";


  const isMobile =
    screenSize <= 900;


  return (
    <div
      className="
        relative
        min-h-screen

        bg-back-secondary
        dark:bg-back-darkprimery

        overflow-x-hidden
      "
    >

      {/* =====================================
          HEADER
      ====================================== */}

      <DashboardHeader />


      {/* =====================================
          MOBILE SIDEBAR OVERLAY
      ====================================== */}

      {activeMenu &&
        isMobile && (

        <button
          type="button"

          aria-label="Close sidebar"

          onClick={() =>
            setActiveMenu(false)
          }

          className="
            fixed
            inset-0

            z-[55]

            bg-color-2/55

            backdrop-blur-[2px]

            lg:hidden
          "
        />

      )}


      {/* =====================================
          SIDEBAR
      ====================================== */}

      <aside
        className={`
          fixed

          top-0
          bottom-0

          z-[60]

          w-[286px]

          transition-transform
          duration-500

          ease-[cubic-bezier(.22,1,.36,1)]

          ${
            isRTL
              ? "right-0"
              : "left-0"
          }

          ${
            activeMenu
              ? "translate-x-0"
              : isRTL
              ? "translate-x-full"
              : "-translate-x-full"
          }
        `}
      >
        <DashboardSideBar />
      </aside>


      {/* =====================================
          MAIN CONTENT
      ====================================== */}

      <main
        className={`
          relative

          min-h-screen

          pt-[82px]

          transition-all
          duration-500

          ${
            activeMenu
              ? `
                lg:ltr:ml-[286px]
                lg:rtl:mr-[286px]
              `
              : ""
          }
        `}
      >
        <DashboardHero />
      </main>

    </div>
  );
}


export default AdminDashboardPage;